import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home, Compass, QrCode, User as UserIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

const TABS = [
  { key: 'home',     path: '/',        label: 'Home',     icon: Home,     testid: 'bottom-tab-home' },
  { key: 'discover', path: '/discover',label: 'Discover', icon: Compass,  testid: 'bottom-tab-discover' },
  { key: 'scan',     path: '/scan',    label: 'Scan',     icon: QrCode,   testid: 'bottom-tab-scan' },
  { key: 'profile',  path: '/profile', label: 'Profile',  icon: UserIcon, testid: 'bottom-tab-profile' },
];

export function BottomTabNav() {
  const nav = useNavigate();
  const loc = useLocation();
  return (
    <nav
      data-testid="bottom-tab-nav"
      style={{ zIndex: 10000 }}
      className="fixed bottom-3 left-1/2 -translate-x-1/2 w-[min(520px,calc(100%-1.5rem))] pb-safe"
    >
      <div className="rounded-2xl border border-white/10 bg-black/55 backdrop-blur-2xl shadow-[0_18px_60px_rgba(0,0,0,0.55)] th-noise">
        <ul className="grid grid-cols-4">
          {TABS.map((tab) => {
            const Icon = tab.icon;
            const active =
              tab.path === '/'
                ? loc.pathname === '/'
                : loc.pathname.startsWith(tab.path);
            return (
              <li key={tab.key}>
                <button
                  data-testid={tab.testid}
                  onClick={() => nav(tab.path)}
                  className={cn(
                    'flex w-full flex-col items-center justify-center gap-1 px-2 py-3 text-xs font-medium transition-colors duration-200',
                    active ? 'text-[#F6B24A]' : 'text-white/70 hover:text-white'
                  )}
                >
                  <Icon className={cn('h-5 w-5', active && 'drop-shadow-[0_0_8px_rgba(246,178,74,0.55)]')} />
                  <span>{tab.label}</span>
                  {active && (
                    <span className="absolute -bottom-0.5 mt-1 h-1 w-6 rounded-full bg-[#F6B24A] shadow-[0_0_10px_rgba(246,178,74,0.6)]" />
                  )}
                </button>
              </li>
            );
          })}
        </ul>
      </div>
    </nav>
  );
}
